import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Col, UncontrolledTooltip } from "reactstrap";

import ProfilePicture from "../../../../Common/ProfilePicture";
import ChangeDisplayName from "../../ChangeDisplayName/ChangeDisplayName";

const UsernameConversation = ({
  id,
  chatId,
  displayName,
  name,
  onChangeDisplayName,
}) => {
  const { t } = useTranslation();
  const { chats } = useSelector((state) => state.Operator.messageOperator);
  const activeChat =
    chats?.data?.find((e) => e.conversationId === chatId) ?? {};
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const onSubmit = (e) => {
    const value = e.success;
    if (value) {
      onChangeDisplayName(value?.chatId, value?.chatDisplayName);
    }
  };

  return (
    <Col md="12" xs="9" className="d-flex py-0">
      <div>
        <ProfilePicture name={displayName} fontsize={16} />
      </div>
      <div
        className="d-flex conversationDisplayName"
        onClick={() => {
          toggle();
        }}
      >
        <ChangeDisplayName
          isOpen={isOpen}
          toggle={toggle}
          conversationId={id}
          chatDisplayName={displayName}
          chatName={name}
          onSubmit={onSubmit}
        />
        <h5 className="font-size-15 mb-0 text-wrap">
          {displayName}
          {activeChat.fromReopen && (
            <>
              <i
                id={`reopen-tooltip-${id}`}
                class="fas fa-reply-all fa-sm ml-1"
              />
              <UncontrolledTooltip
                placement="bottom"
                target={`reopen-tooltip-${id}`}
              >
                {t("Conversation started from reopening")}
              </UncontrolledTooltip>
            </>
          )}
        </h5>
      </div>
    </Col>
  );
};
export default UsernameConversation;
